// Auto-generated normalizer for table: Cat_Roles
export function catRolesNormalize(row) {
  return {
    idRol: row.idRol ?? row.IdRol ?? row['IdRol'] ?? 0,
    nombre: row.nombreRol ?? row.NombreRol ?? row['NombreRol'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    esSistema: row.esSistema ?? row.EsSistema ?? row['EsSistema'] ?? false,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaRegistro: row.fechaRegistro ?? row.FechaRegistro ?? row['FechaRegistro'] ?? null,
  };
}
